<template>
  <div class="term-bank">
    <div class="header">
      <button class="create primary" @click="handleUpload">{{$t('newProjectV2.uploadTerm')}}</button>
      <div class="header-right">
        {{$t('newProjectV2.mounted')}}<span class="num">{{mountNum}}</span>
        <button @click="handleMount" class="mount primary">{{$t('newProjectV2.mount')}}</button>
        <button @click="handleCancelAll" class="create">{{$t('newProjectV2.cancelAll')}}</button>
      </div>
    </div>
    <div class="term-content">
      <el-table
        border
        height="100%"
        ref="multipleTable"
        :data="termList"
        tooltip-effect="dark"
        @selection-change="handleSelectionChange"
        header-row-class-name="customHeader"
      >
        <el-table-column
          align="center"
          type="selection"
          width="55"
        >
        </el-table-column>
        <el-table-column
          :label="$t('newProjectV2.serialNumber')"
          align="center"
          width="55"
        >
          <template slot-scope="{ $index }">
            {{$index + 1}}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('newProjectV2.termBankName')"
          align="center"
          prop="name"
          :show-overflow-tooltip='true'
        ></el-table-column>
        <el-table-column
          :label="$t('newProjectV2.domain')"
          align="center"
        >
          <template slot-scope="{ row }">
            {{ $i18n.locale === 'zh' ? row.domainName : $domainCase[row.domainCode] }}
          </template>
        </el-table-column>
        <el-table-column
          :label="$t('newProjectV2.sentNum')"
          align="center"
          prop="sentCount"
          :show-overflow-tooltip='true'
        >
        </el-table-column>
        <el-table-column
          :label="$t('newProjectV2.mount')"
          align="center"
          prop="isEnable"
        >
          <template slot-scope="{ row }">
            <el-switch
              v-model="row.isEnable"
              active-color="#0078FC"
              inactive-color="#DCDCDC">
            </el-switch>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="term-bottom">
      <el-checkbox v-model="termIntervene" @change="changeTerm">{{$t('newProjectV2.termIntervene')}}</el-checkbox>
    </div>
    <UploadTermBank
      type="create"
      :visible="uploadVisible"
      @handleCancel="handleUploadCancel"
      @updateMemoryBank="updateMemoryBank"
    ></UploadTermBank>
  </div>
</template>

<script>
import UploadTermBank from '@/components/projectDialog/uploadTermBank';

export default {
  name: 'TermBank',
  props: {
    termList: {
      type: Array,
      default () {
        return [];
      }
    },
    openTerm: {
      type: Boolean,
      default () {
        return true
      }
    },
  },
  components: {
    UploadTermBank
  },
  data () {
    return {
      termSelection: [],
      termIntervene: this.openTerm,
      uploadVisible: false,
    }
  },
  methods: {
    handleUpload () {
      this.uploadVisible = true;
    },
    handleUploadCancel () {
      this.uploadVisible = false;
    },
    updateMemoryBank () {
      this.$emit('updateMemoryBank', 'term');
    },
    // checkbox的change事件
    handleSelectionChange (selection) {
      this.termSelection = selection;
    },
    // 挂载
    handleMount () {
      if (this.termSelection.length === 0) {
        this.$message.closeAll();
        this.$message.warning(this.$t('newProjectV2.selTermBankTip'));
      }
      this.termSelection.forEach(item => {
        this.termList.forEach(i => {
          if (i.id === item.id) {
            i.isEnable = true;
          }
        });
      });
      // 取消选中
      this.$refs.multipleTable.clearSelection();
    },
    handleCancelAll () {
      this.termList.forEach(item => {
        item.isEnable = false;
      });
    },
    changeTerm (newVal) {
      this.$emit('changeTerm', newVal);
    },
  },
  computed: {
    mountNum () {
      return this.termList.filter(item => item.isEnable === true).length;
    }
  }
}
</script>

<style lang="less" scoped>
  @import "./assets/style.less";
</style>